export const canEditRecord = (user, record) => {
    if (['admin', 'manager'].includes(user?.role)) return true;
    const actor = user?.userId || user?.id;
    const owner = record?.owner?._id || record?.owner;
    return Boolean(actor && owner && String(actor) === String(owner));
};
